module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic72.de93fdc.woff2";